<script setup lang="ts">
import {
  palette,
  updatePrimaryPalette,
  updateSurfacePalette,
  usePreset,
} from '@primeuix/styled'

import Aura from '@primeuix/themes/aura'
import Material from '@primeuix/themes/material'
import Nora from '@primeuix/themes/nora'
import Lara from '@primeuix/themes/lara'
import type { PaletteDesignToken } from '@primeuix/themes/types'

const context = useContext()

await callOnce(async () => await context.fetchContext())

usePreset(context.org?.theme === 'aura' ? Aura : context.org?.theme === 'material' ? Material : context.org?.theme === 'nora' ? Nora : Lara)
updatePrimaryPalette(palette('{' + context.org?.primary_color + '}') as PaletteDesignToken)
updateSurfacePalette(palette('{' + context.org?.surface_color + '}') as PaletteDesignToken)

defineOgImageComponent('NuxtSeo', {
  description: context.org?.name,
  headline: context.org?.current_season.name,
  logo: context.org?.logo,
})

useHead({
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
  ],
  htmlAttrs: {
    class: [
      context.org?.dark_mode ? 'darkmode' : '',
    ].join(' '),
  },
})
</script>

<template>
  <div class="max-w-7xl mx-auto p-1 md:p-4 flex flex-col gap-4">
    <Header />
    <NuxtPage />
    <ScrollTop />
    <Footer />
  </div>
</template>

<style>
body {
  overflow-y: scroll;
}
</style>
